import {
  FormControlLabel,
  FormControlLabelProps,
  Switch as SwitchMUI,
  SwitchProps as SwitchPropsMUI,
} from '@mui/material';
import { FunctionComponent } from 'react';

export type SwitchProps = {
  onLabel?: string;
  offLabel?: string;
  labelProps?: Partial<FormControlLabelProps>;
} & SwitchPropsMUI;

export const Switch: FunctionComponent<SwitchProps> = (props) => {
  const { labelProps, offLabel, onLabel, ...switchProps } = props;
  const switchComponent = <SwitchMUI {...switchProps} />;

  if (offLabel && onLabel) {
    return (
      <FormControlLabel
        control={switchComponent}
        label={switchProps.checked ? onLabel : offLabel}
        {...labelProps}
      />
    );
  }
  return switchComponent;
};
